import dayjs from 'dayjs';

import { buildSelector } from '@/shared/lib/store';
import type { RangeValueType } from '@/shared/types/antd';

const DEFAULT_VALUE: RangeValueType<DateString> = [
    dayjs().add(-30, 'd').format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD'),
];

export const [useGetTradingPlatformDateRangeValue] = buildSelector(
    (state) => state.tradingPlatform?.dateRange || DEFAULT_VALUE,
);
